import { useCallback } from 'react';
import * as useCases from './useCases';

// we have to duplicate this because we can not import from outside src
// putting the browser extension code inside src is problematic
//  we would need to exclude that folder from linting and testing
//  found that exclusion very hard to do
// importing from outside src is also problematic
//  we would need to extend react-script config to allow this
//  https://stackoverflow.com/questions/44114436/the-create-react-app-imports-restriction-outside-of-src-directory
export const AVAILABLE_COMMANDS = {
  LOAD_SPANISH_TRANSLATIONS: {
    command: 'LOAD_SPANISH_TRANSLATIONS',
    label: 'Load spanish translations',
  },
  LOAD_ENGLISH_TRANSLATIONS: {
    command: 'LOAD_ENGLISH_TRANSLATIONS',
    label: 'Load english translations',
  },
  LOAD_FRENCH_TRANSLATIONS: {
    command: 'LOAD_FRENCH_TRANSLATIONS',
    label: 'Load french translations',
  },
  ENABLE_BULK_PERMISSIONS: {
    command: 'ENABLE_BULK_PERMISSIONS',
    label: 'Enable bulk permissions',
  },
  DISABLE_BULK_PERMISSIONS: {
    command: 'DISABLE_BULK_PERMISSIONS',
    label: 'Disable bulk permissions',
  },
  ENABLE_ANALYTICS_PERMISSIONS: {
    command: 'ENABLE_ANALYTICS_PERMISSIONS',
    label: 'Enable analytics permissions',
  },
  DISABLE_ANALYTICS_PERMISSIONS: {
    command: 'DISABLE_ANALYTICS_PERMISSIONS',
    label: 'Disable analytics permissions',
  },
};

const useExtensionCommand = () => {
  const addPermission = useCases.useAddPermission();
  const removePermission = useCases.useRemovePermission();
  const changeLanguage = useCases.useChangeLanguage();

  const consumeCommand = useCallback(
    (command) => {
      switch (command) {
        case AVAILABLE_COMMANDS.ENABLE_BULK_PERMISSIONS.command:
          addPermission('core.can_send_bulks');
          break;
        case AVAILABLE_COMMANDS.DISABLE_BULK_PERMISSIONS.command:
          removePermission('core.can_send_bulks');
          break;
        case AVAILABLE_COMMANDS.ENABLE_ANALYTICS_PERMISSIONS.command:
          addPermission('core.view_analytics');
          break;
        case AVAILABLE_COMMANDS.DISABLE_ANALYTICS_PERMISSIONS.command:
          removePermission('core.view_analytics');
          break;
        case AVAILABLE_COMMANDS.LOAD_SPANISH_TRANSLATIONS.command:
          changeLanguage('es-ES');
          break;
        case AVAILABLE_COMMANDS.LOAD_ENGLISH_TRANSLATIONS.command:
          changeLanguage('en-GB');
          break;
        case AVAILABLE_COMMANDS.LOAD_FRENCH_TRANSLATIONS.command:
          changeLanguage('fr-FR');
          break;
        default:
          break;
      }
    },
    [addPermission, removePermission, changeLanguage]
  );

  return consumeCommand;
};

export default useExtensionCommand;
